import React from 'react';
import useIsMobile from '../hooks/useIsMobile';

export interface WithIsMobileInjectedProps {
  isMobile: boolean;
  children: any;
}

export default function withIsMobile<WrappedComponentProps>(
  WrappedComponent: React.ComponentType<
    WrappedComponentProps & WithIsMobileInjectedProps
  >,
) {
  const WithIsMobile: React.FC<WrappedComponentProps> = ({ ...toPass }) => {
    const isMobile = useIsMobile();
    return <WrappedComponent {...(toPass as any)} isMobile={isMobile} />;
  };

  return React.memo(WithIsMobile as any);
}
